import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';

/**
 * @Example usage
 * <fin-skeleton-loader [loadingMessage]="'wow'" [announce]="true">
 *   <div class="skeleton-row">
 *     <div style="width: 100px; height: 100px; border-radius: 50%;"></div>
 *     <div style="width: 400px; height: 200px"></div>
 *   </div>
 *   <div style="width: 50%;"></div>
 *   <div style="width: 100%;"></div>
 *   <div class="skeleton-row">
 *     <div style="width: 30%;"></div>
 *     <div style="width: 60%;"></div>
 *   </div>
 *   <div style="width: 20%;"></div>
 * </fin-skeleton-loader>
 */
@Component({
  selector: 'fin-skeleton-loader',
  templateUrl: './skeleton-loader.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./skeleton-loader.component.scss'],
})
export class SkeletonLoaderComponent {
  announce = input<boolean>(false);
  loadingMessage = input('Loading content...');

  role = computed(() => (this.announce() ? 'status' : null));
  ariaBusy = computed(() => (this.announce() ? 'true' : null));
  ariaHidden = computed(() => (this.announce() ? null : 'true'));
}
